import isNumeric from './isNumeric';

/**
 * Attempts to coerce the given value if it resembles an integer.
 * Returns the coerced value as a numeric type when possible. Otherwise, returns
 * the value that was given.
 * @param {*} n
 */
const coerceToInteger = n => {
  if (isNumeric(n)) {
    return n;
  }

  const integerRegex = /^\d+$/;

  if (typeof n === 'string' && integerRegex.test(n)) {
    return parseInt(n, 10);
  }

  return n;
};

export default coerceToInteger;
